import React from 'react';

/* A tappable record row: icon, title, subtitle, optional state pill, chevron.
   Ported from HubRow in the apps' Recruit ▸ Me card.

   `state` tones the pill only — the label is the caller's, because "1 to add"
   is specific to what that row is missing. */

const Chevron = () => (
  <svg className="me-hubrow__chevron" width="14" height="14" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M9 18l6-6-6-6" />
  </svg>
);

export default function HubRow({ icon, title, subtitle, state = 'done', pillLabel, onClick, testId }) {
  return (
    <button type="button" className="me-hubrow" onClick={onClick} data-testid={testId}>
      <span className="me-hubrow__icon" aria-hidden="true">{icon}</span>
      <span className="me-hubrow__body">
        <span className="me-hubrow__title">{title}</span>
        <span className="me-hubrow__sub">{subtitle}</span>
      </span>
      {pillLabel && (
        <span className={`me-hubrow__pill me-hubrow__pill--${state}`}>{pillLabel}</span>
      )}
      <Chevron />
    </button>
  );
}
